export default __webpack_public_path__ + "static/media/warningGreen.773e6d63.svg";